import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
import {
    IconButton,
    Tooltip,
} from '@mui/material';
import { hideToast } from '../reducers/uiReducer';

const useStyles = makeStyles(() => ({
    alertContainer: {
        position: 'absolute',
        top: 64,
        marginLeft: 5,
        width: '400px',
        display: 'flex',
        zIndex: 1300, // Ensure it appears above other content
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        opacity: 0,
        transform: 'translateX(-10px)',
        transition: 'opacity 0.25s ease-in-out, transform 0.25s ease-in-out',
    },
    alertContainerVisible: {
        opacity: 1,
        transform: 'translateX(0)',
    },
    alert: {
        display: 'flex',
        width: '100%', // Adjust width as needed
        padding: '16px',
        borderRadius: '4px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    success: {
        backgroundColor: '#4caf50',
    },
    error: {
        backgroundColor: '#f44336',
    },
    warning: {
        backgroundColor: '#ff9800',
    },
    info: {
        backgroundColor: '#2196f3',
    },
}));

const AlertBar = ({ open, onClose, severity, message }) => {
    const classes = useStyles();
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();

    const handleClose = () => {
        setVisible(false);
        dispatch(hideToast());
    }

    useEffect(() => {
        if (open) {
            setVisible(true);
            const timer = setTimeout(onClose, 4000);
            return () => clearTimeout(timer);
        } else {
            setVisible(false);
        }
    }, [open, onClose]);

    if (!open) return null;

    return (
        <Box className={`${classes.alertContainer} ${visible ? classes.alertContainerVisible : ''}`}>
            <Box className={`${classes.alert} ${classes[severity]}`}>
                <Typography>{message}</Typography>
                <Tooltip title="close">
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default AlertBar;